import React, { useEffect } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import { Row, Col,Container, Button } from 'react-bootstrap'

import { Content,Footer,Img, Label } from './styles'
import Approved from '../../assets/aprovado.png'
import Denied from '../../assets/naoAprovado.png'
import { trackHotelBooking } from 'utils/analytics';


export function CheckoutTravelMessage () {

    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        if (!id) return;
        const stored = localStorage.getItem("hotel_booking_event");
        if (!stored) return;

        try {
            const payload = JSON.parse(stored);
            if (payload) {
                trackHotelBooking({
                    ...payload,
                    order_id: id || payload.order_id,
                });
            }
        } catch (err) {
            console.error("Failed to read hotel booking event:", err);
        } finally {
            localStorage.removeItem("hotel_booking_event");
        }
    }, [id]);

    const SuccessMessage = () => {
        return (
            <>
                <Row className="justify-content-center">
                    <Img src={Approved} alt="" className="img-fluid"/>
                    <Label>Pedido feito com sucesso!</Label>
                </Row>
                <Row className="justify-content-center">

                </Row>
                <Row className="justify-content-center text-center bg-gray rounded">
                    <Col className="p-4">
                        <p className="color-wl font-wl-400 text-mg m-0">Nº do pedido</p>
                        <h3 className="color-text-dark  font-wl-600">{id}</h3>
                    </Col>
                </Row>
                <Row className="py-4">
                    <p className="color-text-dark text-center text-mg font-wl-400">
                        Você receberá todas as informações de sua reserva em seu e-mail cadastrado.
                    </p>
                </Row>
            </>
        )
    }

    const ErrorMessage = () => {
        return (
            <>
                <Row className="justify-content-center">
                    <Img src={Denied} alt="" className="img-fluid"/>
                    <Label>Pedido não aprovado!</Label>
                </Row>
                <Row className="py-4">
                    <p className="color-text-dark text-center text-mg font-wl-400">
                        Não foi possível processar o seu pedido.<br/> Confira seus dados e tente novamente.
                    </p>
                </Row>
            </>
        )
    }

    return (
        <>
            <Container>
                <Content>
                    { id ? <SuccessMessage /> : <ErrorMessage/> }
                </Content>
            </Container>
            <Footer>
                <Button type="button" className="btn-default-wl"
                        onClick={() => navigate('/loja/hoteis/')}>VOLTAR AO MENU VIAGENS
                </Button>
            </Footer>
        </>
    )
}
